import { Action } from '@ngrx/store';
import moment from 'moment';
import { DayModel } from './models/day.model';

export const INIT = '[Calendar] Init';
export const INIT_SUCCESS = '[Calendar] Init Success';
export const INIT_FAIL = '[Calendar] Init Fail';
export const SET_LOADING = '[Calendar] Set Loading';

export class InitAction implements Action {
    readonly type = INIT;

    constructor(public payload: {
        accountId: string,
        startDate: moment.Moment
    }) {
    }
}

export class InitSuccessAction implements Action {
    readonly type = INIT_SUCCESS;

    constructor(public payload: {
        dates: Array<DayModel>,
        startDate: moment.Moment
    }) {
    }
}

export class InitFailAction implements Action {
    readonly type = INIT_FAIL;

    constructor(public payload: {error: Error}) {
    }
}

export class SetLoadingAction implements Action {
    readonly type = SET_LOADING;

    constructor(public payload: {loading: boolean}) {
    }
}

export type Actions
    = InitAction
    | InitSuccessAction
    | SetLoadingAction
    ;



// WEBPACK FOOTER //
// ./src/vas/pages/job-calendar/calendar.actions.ts